/* Floating contact launcher — runs on all store pages. */
(function () {
  var launcher = document.getElementById('clLauncher');
  var btn      = document.getElementById('clBtn');
  var options  = document.getElementById('clOptions');
  var aiBtn    = document.getElementById('clAiBtn');
  if (!launcher || !btn || !options) return;

  var open = false;

  function setOpen(state) {
    open = state;
    btn.classList.toggle('is-open', open);
    options.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
    options.setAttribute('aria-hidden', String(!open));
  }

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    setOpen(!open);
  });

  if (aiBtn) {
    aiBtn.addEventListener('click', function () {
      setOpen(false);
      if (window.ChatWidget) {
        window.ChatWidget.open();
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (open && !launcher.contains(e.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (open && e.key === 'Escape') setOpen(false);
  });
})();
